import * as React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import styled from 'styled-components'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const Error = styled.div`
  color: red;
`

const StyledLabel = styled.label`
  font-weight: 500;
  margin: 4px;
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
    margin-left: 10px;
  }
`

export const InputBase = styled.input`
  border: var(--border-size) solid var(--primary-light);
  border-radius: var(--border-radius);
  height: calc(var(--spacing) * 14);
  padding: 0 calc(var(--spacing) * 4);
  transition: all 300ms;
  &::placeholder {
    color: var(--primary-light);
  }
  &:focus {
    border-color: var(--primary);
  }
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  [type='number'] {
    -moz-appearance: textfield;
  }
`

export const Input = ({
  label,
  id,
  onChange,
  value,
  placeholder,
  error,
  type = 'text',
  onKeyUp,
  disabled,
  inputCss,
  onKeyPress,
  onKeyDown,
  appendIcon,
  tooltiptext,
  accept = null,
}) => (
  <StyledContainer>
    {label && !appendIcon && <StyledLabel htmlFor={id}>{label}</StyledLabel>}
    {label && appendIcon && (
      <StyledLabel htmlFor={id}>
        {label}
        <div data-tooltip={tooltiptext} className="tooltip">
            <img
              src={appendIcon}
              alt="Icon"
              layout="constrained"
              placeholder="tracedSVG"
            />
          </div>
      </StyledLabel>
    )}
    <InputBase
      hasError={!!error}
      id={id}
      onChange={onChange}
      accept={accept}
      value={value}
      placeholder={placeholder}
      type={type}
      onKeyUp={onKeyUp}
      onKeyDown={onKeyDown}
      onKeyPress={onKeyPress}
      disabled={disabled}
      css={inputCss}
    />
    {error && <Error>{error}</Error>}
  </StyledContainer>
)
